import { render } from "./SectionFeatures.vue?vue&type=template&id=86e3c86a&scoped=true"
import script from "./SectionFeatures.vue?vue&type=script&lang=js"
export * from "./SectionFeatures.vue?vue&type=script&lang=js"

import "./SectionFeatures.vue?vue&type=style&index=0&id=86e3c86a&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e3c86a"]])

export default __exports__